export const Polyfill = {
	getRequestAnimationFrame() {
		if (window.requestAnimationFrame) {
			return;
		}

		let lastTime = 0;
		const vendors = ['ms', 'moz', 'webkit', 'o'];
		let x: number;
		let length: number;
		let currentTime: number;
		let timeToCall: number;

		for (x = 0, length = vendors.length; x < length && !window.requestAnimationFrame; ++x) {
			window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
			window.cancelAnimationFrame =
				window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
		}

		if (!window.requestAnimationFrame) {
			window.requestAnimationFrame = ((callback: FrameRequestCallback) => {
				currentTime = new Date().getTime();
				timeToCall = Math.max(0, 16 - (currentTime - lastTime));
				lastTime = currentTime + timeToCall;
				return window.setTimeout(function() {
					callback(currentTime + timeToCall);
				},
				timeToCall);
			}
			);
		}

		if (!window.cancelAnimationFrame) {
			window.cancelAnimationFrame = ((id)  => {
				clearTimeout(id);
			});
		}
	}
};
